<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/review.webp"
  >
    <ng-container i18n
      >Reviews represent feedback from guests regarding their stay, which can be submitted, responded to, or monitored.
      Actions include notifying the user about new reviews, sending responses, and tracking review status. Managing
      reviews allows users to engage with feedback and improve guest satisfaction.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.ReviewHostSubmitted)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ReviewHostSubmitted ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Review submitted by Host
        </button>
        <!--        <button-->
        <!--          type="button"-->
        <!--          (click)="onSelectEvent(events.ReviewPending)"-->
        <!--          class="btn btn-sm"-->
        <!--          [ngClass]="selectedEvent === events.ReviewPending ? 'btn-info' : 'btn-outline-light'"-->
        <!--        >-->
        <!--          Pending-->
        <!--        </button>-->
        <button
          type="button"
          (click)="onSelectEvent(events.ReviewGuestSubmitted)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.ReviewGuestSubmitted ? 'btn-info' : 'btn-outline-light'"
        >
          Receive Guest Review
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.ReviewHostSubmitted" [ngTemplateOutlet]="submittedEvent"></ng-template>
        <ng-template *ngSwitchCase="events.ReviewPending" [ngTemplateOutlet]="pendingEvent"></ng-template>
        <ng-template *ngSwitchCase="events.ReviewGuestSubmitted" [ngTemplateOutlet]="guestReceivedEvent"></ng-template>
      </ng-container>
      <div class="flex-fill"></div>

      <div class="row">
        <div class="col-md-6">
          <app-rental-select
            [ctrl]="form.get('rentals')"
            i18n-label
            i18n-placeholder
            label="From these Rentals"
            placeholder="Apply to all rentals"
            class="mat-block"
          >
          </app-rental-select>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Review is Submitted by Host</h6>
    <ng-template [ngTemplateOutlet]="submittedEvent"></ng-template>
  </div>
  <!--  <div class="container-box shadow">-->
  <!--    <h6 class="text-uppercase m-0 px-3 py-2">Review is Pending</h6>-->
  <!--    <ng-template [ngTemplateOutlet]="pendingEvent"></ng-template>-->
  <!--  </div>-->
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2">Receive Guest Review</h6>
    <ng-template [ngTemplateOutlet]="guestReceivedEvent"></ng-template>
  </div>
</div>

<ng-template #submittedEvent>
  <app-notify-guest-automation
    [event]="events.ReviewHostSubmitted"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify Guest"
    name="Notify Guest if review is submitted by Host"
    [disabled]="true"
    i18n-customTooltip
    customTooltip="Coming Soon"
    [messageSubject]="guestNotificationMessages[events.ReviewHostSubmitted].subject"
    [messageBody]="guestNotificationMessages[events.ReviewHostSubmitted].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>
  <app-do-action-automation
    [event]="events.ReviewHostSubmitted"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.SendToZapier"
    i18n-label
    i18n-name
    label="Send it to Zapier"
    name="Send it to Zapier when review is submitted by Host"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>
</ng-template>

<ng-template #pendingEvent>
  <app-do-action-automation
    [event]="events.ReviewPending"
    [handler]="eventHandlers.ReviewRespond"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Respond to Guest review automatically"
    [disabled]="true"
    i18n-customTooltip
    customTooltip="Coming Soon"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-guest-automation
    [event]="events.ReviewPending"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Remind guest for pending review"
    [disabled]="true"
    i18n-customTooltip
    customTooltip="Coming Soon"
    [messageSubject]="guestNotificationMessages[events.ReviewPending].subject"
    [messageBody]="guestNotificationMessages[events.ReviewPending].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>
</ng-template>

<ng-template #guestReceivedEvent>
  <app-notify-users-automation
    [event]="events.ReviewGuestSubmitted"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Notify user(s) that a guest review is received"
    [messageSubject]="userNotificationMessages[events.ReviewGuestSubmitted].subject"
    [messageBody]="userNotificationMessages[events.ReviewGuestSubmitted].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>

  <!-- <app-do-action-automation
        [event]="events.ReviewGuestSubmitted"
    [handler]="eventHandlers.ReviewRespond"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    label="Respond to Guest review automatically"
    [disabled]="true"
    i18n-customTooltip
    customTooltip="Coming Soon"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-do-action-automation
    [event]="events.ReviewGuestSubmitted"
    [handler]="eventHandlers.ReviewDraftAIReview"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Draft AI based review"
    name="Draft AI based review  when receiving review from guest"
    [disabled]="true"
    i18n-customTooltip
    customTooltip="Coming Soon"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-do-action-automation
    [event]="events.ReviewGuestSubmitted"
    [handler]="eventHandlers.ReviewSendAIReview"
    [type]="type"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Send AI based review"
    name="Send AI based review when receiving review from guest"
    [disabled]="true"
    i18n-customTooltip
    customTooltip="Coming Soon"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation> -->
</ng-template>
